import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
/**
 * Merge Assignment Request Schema
 * POST /api/v2/process-step-assignment/:assignmentId/merge
 */ export const MergeAssignmentRequestSchema = z.object({
    targetStepRecordingId: z.string().regex(/^[a-f\d]{24}$/i)
});
/**
 * Merge Assignment Response Schema
 */ export const MergeAssignmentResponseSchema = z.object({
    success: z.literal(true)
});
/**
 * Merge Assignment Error Schema
 */ export const MergeAssignmentErrorSchema = BaseErrorSchema;

//# sourceMappingURL=merge-assignment.schema.js.map